import React from 'react';
import {MessageDescriptor} from '@lingui/core';

import {IMenuEntry, LabelMenu} from 'widgets/layout';

import {MenuGroupKey, Permission} from 'entities/user';

import {AppUrls} from '../shared/config/model/urls';
import {Pages} from '../shared/config/model/pages';
import {isTranslate} from '../shared/lib/lang';
import HomeIcon from '../shared/ui/icons/NavMenu/HomeIcon';
import MonitorsIcon from '../shared/ui/icons/NavMenu/MonitorsIcon';
import IncidentsIcon from '../shared/ui/icons/NavMenu/IncidentsIcon';
import UserReportsIcon from '../shared/ui/icons/NavMenu/UserReportsIcon';
import StatusPagesIcon from '../shared/ui/icons/NavMenu/StatusPagesIcon';
import TariffsIcon from '../shared/ui/icons/NavMenu/TariffsIcon';
import PaymentsIcon from '../shared/ui/icons/NavMenu/PaymentsIcon';
import UsersIcon from '../shared/ui/icons/NavMenu/UsersIcon';
import SettingsIcon from '../shared/ui/icons/NavMenu/SettingsIcon';
import SupportIcon from '../shared/ui/icons/NavMenu/SupportIcon';
import NewsIcon from '../shared/ui/icons/NavMenu/NewsIcon';
import PromosIcon from '../shared/ui/icons/NavMenu/PromosIcon';
import ReportsIcon from '../shared/ui/icons/NavMenu/ReportsIcon';
import CitiesIcon from '../shared/ui/icons/NavMenu/CitiesIcon';
import PromoCodesIcon from '../shared/ui/icons/NavMenu/PromoCodesIcon';
import ServersIcon from '../shared/ui/icons/NavMenu/ServersIcon';
import DomainsIcon from '../shared/ui/icons/NavMenu/DomainsIcon';
import PortsIcon from '../shared/ui/icons/NavMenu/PortsIcon';

export const menuGroups: Record<MenuGroupKey, {title: MessageDescriptor, icon: React.ReactElement}> = {
    monitoring: {
        title: Pages.MONITORING_GROUP,
        icon: <MonitorsIcon/>,
    },
    incidents: {
        title: Pages.INCIDENTS_GROUP,
        icon: <IncidentsIcon/>,
    },
};

export const menuItems: IMenuEntry[] = [
    {
        path: AppUrls.HOME,
        auth: [Permission.USER],
        title: Pages.HOME,
        icon: <HomeIcon/>,
    },
    {
        path: AppUrls.HTTP_MONITORS,
        auth: [Permission.USER],
        title: Pages.HTTP_MONITORS,
        icon: <MonitorsIcon/>,
        menuGroup: 'monitoring',
        menuLabel: Pages.MENU_SITES,
    },
    {
        path: AppUrls.SERVERS,
        auth: [Permission.USER],
        title: Pages.SERVERS,
        icon: <ServersIcon/>,
        label: <LabelMenu/>,
        menuGroup: 'monitoring',
        menuLabel: Pages.MENU_SERVERS,
    },
    {
        path: AppUrls.PORT_MONITORS,
        auth: [Permission.USER],
        title: Pages.PORT_MONITORS,
        icon: <PortsIcon/>,
        label: <LabelMenu/>,
        menuGroup: 'monitoring',
        menuLabel: Pages.MENU_PORTS,
    },
    {
        path: AppUrls.DOMAIN_MONITORS,
        auth: [Permission.USER],
        title: Pages.DOMAIN_MONITORS,
        icon: <DomainsIcon/>,
        label: <LabelMenu/>,
        menuGroup: 'monitoring',
        menuLabel: Pages.MENU_DOMAINS,
    },
    {
        path: AppUrls.HTTP_INCIDENTS,
        auth: [Permission.USER],
        title: Pages.HTTP_INCIDENTS,
        icon: <IncidentsIcon/>,
        menuGroup: 'incidents',
        menuLabel: Pages.MENU_SITES,
    },
    {
        path: AppUrls.SERVER_INCIDENTS,
        auth: [Permission.USER],
        title: Pages.SERVER_INCIDENTS,
        icon: <IncidentsIcon/>,
        label: <LabelMenu/>,
        menuGroup: 'incidents',
        menuLabel: Pages.MENU_SERVERS,
    },
    {
        path: AppUrls.PORT_INCIDENTS,
        auth: [Permission.USER],
        title: Pages.PORT_INCIDENTS,
        icon: <IncidentsIcon/>,
        label: <LabelMenu/>,
        menuGroup: 'incidents',
        menuLabel: Pages.MENU_PORTS,
    },
    {
        path: AppUrls.DOMAIN_INCIDENTS,
        auth: [Permission.USER],
        title: Pages.DOMAIN_INCIDENTS,
        icon: <IncidentsIcon/>,
        label: <LabelMenu/>,
        menuGroup: 'incidents',
        menuLabel: Pages.MENU_DOMAINS,
    },
    {
        path: AppUrls.STATUS_PAGES,
        auth: [Permission.USER],
        title: Pages.STATUS_PAGES,
        icon: <StatusPagesIcon/>,
    },
    {
        path: AppUrls.USER_REPORTS,
        auth: [Permission.USER],
        title: Pages.USER_REPORTS,
        icon: <UserReportsIcon/>,
    },
    {
        path: isTranslate() ? AppUrls.PRICING : AppUrls.TARIFFS,
        auth: [Permission.USER],
        title: Pages.TARIFFS,
        icon: <TariffsIcon/>,
    },
    {
        path: AppUrls.ADMIN_TARIFFS,
        auth: [Permission.ADMIN],
        title: Pages.ADMIN_TARIFFS,
        icon: <TariffsIcon/>,
    },
    {
        path: AppUrls.ADMIN_TARIFF_VARIANTS,
        auth: [Permission.ADMIN],
        title: Pages.ADMIN_TARIFF_VARIANTS,
        icon: <TariffsIcon/>,
    },
    {
        path: AppUrls.ADMIN_PROMO_CODES,
        auth: [Permission.ADMIN],
        title: Pages.ADMIN_PROMO_CODES,
        icon: <PromoCodesIcon/>,
    },
    {
        path: AppUrls.ADMIN_PAYMENTS,
        auth: [Permission.ADMIN],
        title: Pages.ADMIN_PAYMENTS,
        icon: <PaymentsIcon/>,
    },
    {
        path: AppUrls.PAYMENTS,
        auth: [Permission.USER],
        title: Pages.PAYMENTS,
        icon: <PaymentsIcon/>,
        hidden: isTranslate(),
    },
    {
        path: AppUrls.ADMIN_USERS,
        auth: [Permission.ADMIN],
        title: Pages.USERS,
        icon: <UsersIcon/>,
    },
    {
        path: AppUrls.ADMIN_REPORTS,
        auth: [Permission.ADMIN],
        title: Pages.ANALYTICS,
        icon: <ReportsIcon/>,
    },
    {
        path: AppUrls.ADMIN_CITIES,
        auth: [Permission.ADMIN],
        title: Pages.CITIES,
        icon: <CitiesIcon/>,
    },
    {
        path: AppUrls.ADMIN_LOCATIONS,
        auth: [Permission.ADMIN],
        title: Pages.LOCATIONS,
        icon: <CitiesIcon/>,
    },
    {
        path: AppUrls.SETTINGS,
        auth: [Permission.USER],
        title: Pages.SETTINGS,
        icon: <SettingsIcon/>,
    },
    {
        path: AppUrls.NEWS,
        auth: [Permission.USER],
        title: Pages.NEWS,
        icon: <NewsIcon/>,
        target: '_blank',
        hidden: isTranslate(),
    },
    {
        path: AppUrls.PROMOS,
        auth: [Permission.USER],
        title: Pages.PROMOS,
        icon: <PromosIcon />,
        target: '_blank',
        hidden: isTranslate(),
    },
    {
        path: AppUrls.SUPPORT,
        auth: [Permission.USER],
        title: Pages.SUPPORT,
        icon: <SupportIcon/>,
        target: '_blank',
        hidden: isTranslate(),
    },
];
